import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, LockIcon, SmartphoneIcon, CreditCardIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/wfCwzazkJgFyupSqRqJKQJ/heylloyd-image-1771802598740_reset_cortisol.png';
export function OfferSection() {
  return <section id="offer-section" className="bg-forest py-16 md:py-24" aria-labelledby="offer-heading" data-id="element-90">
      <div className="max-w-5xl mx-auto px-4" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-92">
          <p className="font-sans text-terracotta text-xs font-700 tracking-[0.2em] uppercase mb-4" data-id="element-93">
            Today's Offer
          </p>
          <h2 id="offer-heading" className="font-serif text-cream text-3xl md:text-4xl lg:text-5xl font-700 leading-tight" data-id="element-94">
            Get the Complete Cortisol Reset Kitchen System
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-95">
          {/* Value Stack */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-96">
            <ul className="space-y-4 mb-8" role="list" data-id="element-97">
              <li className="flex items-start gap-3" data-id="element-98">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-99" />
                <span className="font-sans text-cream text-base" data-id="element-100">
                  The 21-Day Thermal Window Flush{' '}
                  <span className="text-sage text-sm" data-id="element-101">($47 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-102">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-103" />
                <span className="font-sans text-cream text-base" data-id="element-104">
                  The Sleep-to-Slim Connection Protocol{' '}
                  <span className="text-sage text-sm" data-id="element-105">($27 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-106">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-107" />
                <span className="font-sans text-cream text-base" data-id="element-108">
                  The Adrenal Grocery List{' '}
                  <span className="text-sage text-sm" data-id="element-109">($17 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-110">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-111" />
                <span className="font-sans text-cream text-base" data-id="element-112">
                  40+ Anti-Inflammatory Recipes{' '}
                  <span className="text-sage text-sm" data-id="element-113">($37 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-114">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-115" />
                <span className="font-sans text-cream text-base" data-id="element-116">
                  <span className="text-terracotta font-700" data-id="element-117">BONUS:</span>{' '}
                  Cortisol SOS Guide{' '}
                  <span className="text-sage text-sm" data-id="element-118">($17 value — FREE)</span>
                </span>
              </li>
            </ul>

            {/* Price */}
            <div className="bg-white/10 rounded-2xl p-6 mb-6 border border-white/20" data-id="element-119">
              <p className="font-sans text-sage text-sm mb-1" data-id="element-120">Total Value:</p>
              <p className="font-serif text-cream/60 text-2xl line-through mb-1" data-id="element-121">
                $145
              </p>
              <p className="font-serif text-cream text-4xl font-700" data-id="element-122">
                Today Only: <span className="text-terracotta" data-id="element-123">$27</span>
              </p>
              <p className="font-sans text-sage text-sm mt-2" data-id="element-124">
                The price of one lunch. The solution you've been searching for.
              </p>
            </div>

            {/* CTA */}
            <a href="https://buenavibrax.com/cart/45502602674233:1" className="block w-full bg-terracotta hover:bg-terracotta/90 text-white font-sans font-700 text-lg px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 mb-5 text-center" aria-label="Get instant access to the Cortisol Reset Kitchen for $27" data-id="element-125">
              YES! Give Me Instant Access for $27 →
            </a>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-4 text-sage text-sm font-sans" data-id="element-126">
              <span className="flex items-center gap-1.5" data-id="element-127">
                <LockIcon className="w-4 h-4" aria-hidden="true" data-id="element-128" />
                Secure Checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-129">
                <SmartphoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-130" />
                Instant Download
              </span>
              <span className="flex items-center gap-1.5" data-id="element-131">
                <CreditCardIcon className="w-4 h-4" aria-hidden="true" data-id="element-132" />
                All Cards Accepted
              </span>
            </div>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="flex justify-center" data-id="element-133">
            <div className="relative" data-id="element-134">
              <div className="absolute inset-0 bg-terracotta/20 rounded-3xl blur-2xl transform scale-90 translate-y-6" aria-hidden="true" data-id="element-135" />
              <img src={PRODUCT_IMAGE} alt="The Cortisol Reset Kitchen digital guide" className="relative w-full max-w-xs rounded-2xl shadow-2xl" data-id="element-136" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}